import { writable } from 'svelte/store';

export const pageStack = writable<string[]>([]);
export const forwardStack = writable<string[]>([]);

export const isPressingBack = writable<boolean>(false);
export const isPressingForward = writable<boolean>(false);
export const isAutoForward = writable<boolean>(false);

export const lastPage = writable<string>('');
